var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gbpro-rich-text"},[_vm._l((_vm.parts),function(part,index){return [(part.type === 'link')?_c('a',{key:`link-${index}`,staticClass:"gbpro-inline-link",attrs:{"href":part.href}},[_vm._v("\n"+_vm._s(part.content)+"\n")]):[_vm._v("\n"+_vm._s(part.content)+"\n")]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }